import { Validator } from './Validator';

export type FormErrors = {
	tel: string;
	zip: string;
	pref_cd: string;
	address_2: string;
	address_3: string;
	address_4: string;
	nickname: string;
	country: string;
};

export const initialFormErrors: FormErrors = {
	tel: '',
	zip: '',
	pref_cd: '',
	address_2: '',
	address_3: '',
	address_4: '',
	nickname: '',
	country: '',
};

/**
 * 項目ごとにバリデーションチェックをし、エラーメッセージを返す
 * @param name 項目名
 * @param value 値
 * @param displayType 表示タイプ 1：表示＆必須入力, 2：表示＆任意入力
 * @returns エラーメッセージ or 空文字
 */
export const getErrorMessage = <T>(name: string, value: T, displayType: number): string => {
	const validator = new Validator(value);
	const isRequired = 1 === displayType;
	const isNone = 3 === displayType;
	// 非表示項目の場合スルー
	if (isNone) {
		return '';
	}
	switch (name) {
		case 'tel':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeTel().end();
		case 'zip':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeZip().end();
		case 'pref_cd':
			if (isRequired) {
				return validator.require(`該当する都道府県を選択してください。`).end();
			}
			return '';
		case 'address_2':
		case 'address_3':
		case 'address_4':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeFullWidth().end();
		case 'nickname':
			if (isRequired) {
				validator.require();
			}
			return validator.charTypeNickName().end();
		case 'country':
			if (isRequired) {
				return validator.require().end();
			}
			return '';
		default:
			return '';
	}
};
